import React, { useState } from "react";
import "./ImageGrid.css"; // Import your CSS file
import NFC1 from "../Images/NFC/IMG_5545.webp";
import NFC2 from "../Images/NFC/IMG_5554.webp";
import NFC3 from "../Images/NFC/IMG_7282.webp";
import NFC4 from "../Images/NFC/IMG_8335.webp";
import NFC5 from "../Images/NFC/IMG_8339.webp";
import NFC6 from "../Images/NFC/IMG_8342.webp";
import NFC7 from "../Images/NFC/IMG_8350.webp";
import NFC8 from "../Images/NFC/IMG_8362.webp";
import NFC9 from "../Images/NFC/IMG_9674.webp";
import NFC10 from "../Images/NFC/NFC __for website - Approved.webp";

const ImageGrid = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [NFC1, NFC2, NFC3, NFC4, NFC5, NFC6, NFC7, NFC8, NFC9, NFC10];

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const handleCloseCarousel = () => {
    setSelectedImage(null);
  };

  const handleNextImage = () => {
    const currentIndex = images.indexOf(selectedImage);
    if (currentIndex < images.length - 1) {
      setSelectedImage(images[currentIndex + 1]);
    } else {
      setSelectedImage(images[0]);
    }
  };
  const handlePrevImage = () => {
    const currentIndex = images.indexOf(selectedImage);
    if (currentIndex > 0) {
      setSelectedImage(images[currentIndex - 1]);
    }
  };
  return (
    <div className="ui1">
      <div className="ui2">
        <div className="ui3">
          {images.slice(0, 5).map((image, index) => (
            <div key={index} className="image-container">
              <img
                src={image}
                alt={`Image ${index + 1}`}
                onClick={() => handleImageClick(image)}
              />
            </div>
          ))}
        </div>
        <div className="ui3">
          {images.slice(5).map((image, index) => (
            <div key={index} className="image-container">
              <img
                src={image}
                alt={`Image ${index + 6}`}
                onClick={() => handleImageClick(image)}
              />
            </div>
          ))}
        </div>
      </div>

      {selectedImage && (
        <div className="overl">
          <div className="carousel">
            <button className="close-button" onClick={handleCloseCarousel}>
              <i className="fas fa-times"></i>
            </button>
            <button onClick={handlePrevImage}>
              <i className="fa-solid fa-chevron-left"></i>
            </button>
            <img src={selectedImage} alt="Selected" />
            <button onClick={handleNextImage}>
              <i className="fa-solid fa-chevron-right"></i>
            </button>
          </div>{" "}
        </div>
      )}
    </div>
  );
};
export default ImageGrid;
